import React from "react";
import { Link } from "react-router-dom";

import "./SmallViewport.css";

const NotFound404 = () => (
  <div className="bg-image">
    <div className="flex h-screen justify-center items-center overflow-y-hidden">
      <div className="box">
        <div className="text-sm text-center md:text-lg lg:text-lg xl:text-xl 2xl:text-2xl mt-2 text-black font-400 px-1% pt-2">
          Please open on larger viewport to have a better experience!
        </div>
        <Link to="/">
          <div className="mt-8 font-semibold py-2 px-4 cursor-pointer btn">
            <span className="text-sm md:text-lg lg:text-lg xl:text-xl 2xl:text-2xl text-black">
              Go Back
            </span>
          </div>
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound404;
